var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getJson } from '../utility/request';
import { Instant } from '../utility/datetime';
export const fetchPartsTechOrders = (merchantId, from, to) => {
    const params = new URLSearchParams();
    if (from)
        params.set('fromDate', from);
    if (to)
        params.set('toDate', to);
    const qs = params.toString();
    return getJson(`/parts-tech/orders/${merchantId}${qs ? '?' + qs : ''}`);
};
export const fetchPartsTechVoidedItems = (merchantId, invoiceId) => __awaiter(void 0, void 0, void 0, function* () {
    const items = yield getJson(`/parts-tech/voided-items/${merchantId}/${invoiceId}`);
    return items.map((item) => (Object.assign(Object.assign({}, item), { voided: Instant.parse(item.voided) })));
});
export const partsTechVoidReasons = [
    { 'value': 'incorrect-part', 'title': 'Incorrect part' },
    { 'value': 'damaged', 'title': 'Damaged' },
    { 'value': 'customer-declined', 'title': 'Customer declined' },
    { 'value': 'duplicate-order', 'title': 'Duplicate order' },
    { 'value': 'no-longer-needed', 'title': 'No longer needed' },
    { 'value': 'other', 'title': 'Other' },
];
export const partsTechVoidDispositions = [
    { 'value': 'returned-to-vendor', 'title': 'Returned to vendor' },
    { 'value': 'return-pending', 'title': 'Return pending' },
    { 'value': 'kept-for-inventory', 'title': 'Kept for inventory' },
    { 'value': 'discarded', 'title': 'Discarded' },
    { 'value': 'other', 'title': 'Other' },
];
export const partsTechVoidReasonLabel = (r) => { var _a; return ((_a = partsTechVoidReasons.find((x) => x.value === r)) === null || _a === void 0 ? void 0 : _a.title) || r; };
export const partsTechVoidDispositionLabel = (d) => { var _a; return ((_a = partsTechVoidDispositions.find((x) => x.value === d)) === null || _a === void 0 ? void 0 : _a.title) || d; };
export const partsTechVoidedItemPerformer = (item) => [item.voided_by_firstname, item.voided_by_lastname].filter((x) => !!x).join(' ') || '—';
